import React from 'react';

const Sidebar2 = () => {
    return (
        <div>
                <div className="col-sm-2">
                    <div className="col-sm-2 border sideHead" style={{ minWidth: '250px' }}>
                     <div className="mt-2 ">
                    <ul className="m-4">
                        <li className="my-2 my-3 border-bottom border-top p-2 box2">Meat&Fish</li>
                        <li className="my-2 my-3 border-bottom border-top  p-2 box2">Cooking Essentials</li>
                        <li className="my-2 my-3 border-bottom border-top  p-2 box2">Sauces & Pickels</li>
                        <li className="my-2 my-3 border-bottom border-top  p-2 box2">Snakes & Instant Food</li>
                        <li className="mt-2 my-3 border-bottom border-top  p-2 box2">Dry Food</li>
                    </ul>

                </div>
                    </div>

                </div>

        </div>



    );
};

export default Sidebar2;
